<!--
 * @Author: your name
 * @Date: 2020-11-19 18:09:28
 * @LastEditTime: 2021-11-11 15:49:03
 * @LastEditors: zhangcx33595
 * @Description: In User Settings Edit
 * @FilePath: \openplat-web\src\gtn\components\index\indexFooter.vue
-->
<template>
  <div class="index-footer-pannel">
    <div class="contact-wrapper">
      <div class="contact-inner" style="display:none">
        <div class="contact-item">
          <em class="contact-img contact-tel"></em>
          <div class="contact-text-wrapper">
            <p>0571-26695555转7</p>
            <p>工作日早9:00-晚8:00</p>
            <p>休息日早9:00-晚6:00</p>
          </div>
        </div>
        <a
          class="contact-item"
          :href="kfUrl"
          target="_blank"
          @click="
            handleTrack(`帮助中心_在线客服`);
            gioTrackEvent('OP_onlineServiceClick');
          "
        >
          <em class="contact-img contact-person"></em>
          <div class="contact-text-wrapper">
            <p>在线客服</p>
            <p>7*24小时客服在线</p>
            <p>实时回答</p>
          </div>
        </a>
        <a
          class="contact-item"
          :href="urlList['工单管理']"
          target="_blank"
          @click="
            handleTrack(`帮助中心_提交工单`);
            gioTrackEvent('OP_issueTicketSubmit');
          "
        >
          <em class="contact-img contact-workOrder"></em>
          <div class="contact-text-wrapper">
            <p>提交工单</p>
            <p>这里可以反馈您的问题</p>
            <p>建议、需求</p>
          </div>
        </a>
      </div>
    </div>
    <page-footer></page-footer>
    <component v-bind:is="dymaticComponent"></component>
  </div>
</template>
<script>
import trackMixin from "@/components/mixins/track.js";
import { mapGetters } from "vuex";
import bottomFooter from "./bottomFooter.vue";
export default {
  name: "indexFooter",
  data() {
    return {
      dymaticComponent: "",
      kfUrl: window.LOCAL_CONFIG.serviceUrl
    };
  },
  mixins: [trackMixin],
  computed: {
    ...mapGetters(["urlList"])
  },
  components: {
    bottomFooter
  },
  methods: {
    openWorkOrder() {
      this.dymaticComponent = () =>
        "@/frontViews/components/createWorkOrder.vue";
    }
  }
};
</script>
<style lang="scss">
.index-footer-pannel {
  // height: 657px;
  // background: #252e49;
  .contact-wrapper {
    width: 100%;

    // border-bottom: 1px solid #666666;
    .contact-inner {
      max-width: 978px;
      margin: 0 auto;
      padding: 63px 0 57px 0;

      .contact-item {
        display: inline-block;
        margin-right: 209px;
        cursor: pointer;

        &:hover {
          .contact-text-wrapper {
            p:first-child {
              color: #3060ff;
            }

            p {
              color: #3060ff;
            }
          }

          .contact-tel {
            background: url(~@/assets/index/tel-hover.png) 0 0 no-repeat;
          }

          .contact-person {
            background: url(~@/assets/index/kf-hover.png) 0 0 no-repeat;
          }

          .contact-workOrder {
            background: url(~@/assets/index/workOrder-hover.png) 0 0 no-repeat;
          }
        }

        &:last-child {
          margin-right: 0;
        }

        .contact-img {
          height: 54px;
          width: 54px;
          display: inline-block;
          transition: all 500ms;
        }

        .contact-tel {
          background: url(~@/assets/index/tel.png) 0 0 no-repeat;
        }

        .contact-person {
          background: url(~@/assets/index/kf.png) 0 0 no-repeat;
        }

        .contact-workOrder {
          background: url(~@/assets/index/workOrder.png) 0 0 no-repeat;
        }

        .contact-text-wrapper {
          margin-left: 14px;
          display: inline-block;

          p:first-child {
            transition: all 500ms;
            font-size: 14px;
            color: #f2f2f2;
            margin-bottom: 6px;
          }

          p {
            transition: all 500ms;
            font-size: 11.2px;
            color: #999999;
            line-height: 17px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/components/index/indexFooter.vue